import React, { Component } from "react";
import { connect } from "react-redux";

import privatew from "../assets/image/private-w.png";
import privateb from "../assets/image/private-b.png";
import companyw from "../assets/image/company-w.png";
import companyb from "../assets/image/company-b.png";

import "../assets/css/style.css";

class ArbeitslisteScreen extends Component {
  switchCase(kind) {
    this.props.switchCase(kind);
    this.props.switchScreen(3);
  }

  getCases() {
    if (this.props.kind === -1) return [];
    return this.props.cases[this.props.kind];
  }

  displayCurrency(number, curr, locale) {
    if (locale === undefined) {
      locale = "en-US";
    }
    if (curr === undefined) {
      curr = "USD";
    }
    var formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: curr
    });
    return formatter.format(number);
  }

  renderCase(item, index) {
    // console.log(item);
    //Fälligkeit
    var dateFormat = require("dateformat");
    var eindat = new Date(item.sumf.value);
    var raweindat = eindat.getTime() / (1000 * 3600 * 24);
    var roueindat = Math.round(raweindat);
    var rawfalldat = roueindat + 21;
    var falldat = rawfalldat * 1000 * 3600 * 24;
    var falldatum = dateFormat(falldat, "dd.mm.yyyy");

    let icon = companyw;
    let resp = "";

    if (item.kind) resp = item.contact;

    return (
      <div
        key={index}
        className={"case"}
        onClick={() => this.switchCase(index)}
      >
        {this.props.kind === 2 ? null : null}
        <img src={icon} className="privateCompanyIndicator" alt="kiim" />
        <p>
          {item.name.value}
          <br />
          {resp}
        </p>
        <div className={"routineScreenVerticalLine"}></div>
        <p>
          Fällig am
          <br /> {String(falldatum)}
        </p>
        <div className={"routineScreenVerticalLine"}></div>
        <p>
          Rechnungsbetrag <br />
          {this.displayCurrency(item.sumg.value, "EUR", "de-DE")}
        </p>
      </div>
    );
  }

  render() {
    const cases = this.getCases();
    const sortedCases = cases.sort((a, b) => {
      const aDate = new Date(a.sumf.value).getTime();
      const bDate = new Date(b.sumf.value).getTime();

      if (aDate < bDate) return -1;
      if (aDate > bDate) return 1;
      return 0;
    });
    // console.log(this.props);
    // console.log(cases);
    return (
      <div className="arbeitslisteScreen">
        <div className="arbeitslisteContainer">
          <div className="routineTable">
            <div className="cases">
              {sortedCases.map((item, index) => {
                return this.renderCase(item, index);
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases
  };
};

export default connect(mapStateToProps)(ArbeitslisteScreen);



// WEBPACK FOOTER //
// ./src/screens/ArbeitslisteScreen.js